import React, { useRef } from 'react';
import { formatBrowser } from '../utils/dateUtils';
import { useDisableMapEvents } from '../hooks/useDisableMapEvents'

export default function RoseLegend({ data, selectedParam, parameterOptions, periodicityRose, customRange}) {
  const ref = useRef(null);
  useDisableMapEvents(ref);

  const selectedParamObj = parameterOptions.find(opt => opt.id === selectedParam);
  const paramLabel = selectedParamObj ? `${selectedParamObj.name}${selectedParamObj.unit ? ` (${selectedParamObj.unit})` : ''}` : '';


  const fromStr = customRange?.from ? formatBrowser(customRange.from) : '';
  const toStr = customRange?.to ? formatBrowser(customRange.to) : '';

  return (
    <div
      ref={ref}
      className="map-card"
      style={{
        maxWidth: 240
      }}
    >
      <div className="map-card-title">
        Pollution Rose
      </div>

      {paramLabel && (
        <div style={{ marginBottom: 10, fontSize: 12 }}>
          <div>
            <strong>Parameter:</strong> {selectedParamObj?.name}
            {selectedParamObj?.unit && ` (${selectedParamObj.unit})`}
          </div>
          <div>
            <strong>Aggregation:</strong> {periodicityRose}
          </div>
        </div>
      )}

      {fromStr && toStr && (
        <div style={{ marginBottom: 12, fontSize: 12 }}>
          <div><strong>From:</strong> {fromStr}</div>
          <div><strong>To:</strong> {toStr}</div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {data.map((item, idx) => (
          <div key={idx} className="map-card-row">
            <span
              style={{
                width: 18,
                height: 18,
                background: item.color,
                borderRadius: 4,
                border: '1px solid rgba(0,0,0,0.15)'
              }}
            />
            <span style={{ fontSize: 12 }}>
              {decodeHtmlEntities(item.name)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

}

function decodeHtmlEntities(str) {
  if (!str) return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}
